import { useEffect, useState } from 'react';
import { remoteConfig } from '../firebase';
import { getValue, fetchAndActivate } from 'firebase/remote-config';
import useReload from './useReload.hook';
import { ENVIROMENT } from '../assets/constants/enviroments';
const useRemoteConfigWatcher = () => {
    const [parsedConfig, setParsedConfig] = useState({});
    useEffect(() => {
        const fetchRemoteConfig = async () => {
            try {
                await fetchAndActivate(remoteConfig);
                const configStr = getValue(remoteConfig, 'APP_CONFIG').asString();
                if (configStr) {
                    try {
                        const parsed = JSON.parse(configStr);
                        setParsedConfig(parsed);
                        console.log(`Remote Config actualizado (${new Date().toLocaleTimeString()})`, parsed);
                    }
                    catch (err) {
                        console.error('Error parsing APP_CONFIG:', err);
                    }
                }
            }
            catch (err) {
                console.error('Error al activar Remote Config:', err);
            }
        };
        fetchRemoteConfig();
        if (process.env.ENVIRONMENT === ENVIROMENT.STAG) {
            return;
        }
        const intervalMinutes = Number(process.env.REACT_APP_REMOTE_CONFIG_REFRESH_INTERVAL_MINUTES || 1);
        const intervalMs = intervalMinutes * 60 * 1000;
        const intervalId = setInterval(fetchRemoteConfig, intervalMs);
        return () => clearInterval(intervalId);
    }, []);
    useReload(parsedConfig);
};
export default useRemoteConfigWatcher;
